import React, {useEffect, useState} from "react";
import ExchangeRateFormWizard from "../../components/form/ExchangeRateFormWizard";
import {useCreateExchangeRateMutation} from "../../../../../redux/apiSlice";
import {useSubheader} from "../../../../../_metronic/layout";
import cogoToast from "cogo-toast";

export const CreateExchangeRate = ({history, location}) => {
    const subheader = useSubheader();
    useEffect(() => {
        subheader.setTitle("Create Exchange Rate")
    }, [subheader])

    const [tab, setTab] = useState(1);

    const [
        createExchangeRate, // This is the mutation trigger
        {
            isLoading: isCreating,
            isSuccess: createdSuccessfully,
        }, // This is the destructured mutation result
    ] = useCreateExchangeRateMutation()

    /* Clear fields on success */
    useEffect(() => {
        if (createdSuccessfully) {
            cogoToast.success("Created 'Exchange Rate Creation' Action Successfully")
            setTab(1)
            history.push("/exchange-rates/create")
        }
    }, [history, createdSuccessfully]);

    /* Submit exchange rate data */
    const submitData = async data => {
        createExchangeRate({exchangeRate: data});
    }

    return (
        <ExchangeRateFormWizard
            key={location.key}
            tab={tab} // Reset Tab on success
            setTab={setTab}
            isLoading={isCreating}
            submitData={submitData}
        />
    )
}